__webpack_nonce__ = window.CSP_NONCE;